import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './AboutBanner.scss';
import bannerOne from '../../assets/about/banner/banner_1.png'
import bannerTwo from '../../assets/about/banner/banner_2.png'
import pattern from '../../assets/banner/pattern.png'
import { trackContactUsClicked } from '../../utils/analytics';
import { getCurrentTenantSlug, getTenantApiUrl } from '../../tenantConfig';

const AboutBanner = () => {
    const [aboutContent, setAboutContent] = useState({
        name: '',
        tagline: '',
        owner_name: '',
        address: '',
        city: '',
        state: '',
        country: '',
        phone_number: '',
        website: '',
        logo_url: '',
        primary_color: '',
        secondary_color: '',
        about_description: '',
        years_of_experience: '',
        specialties: '',
        certifications: '',
        mission_statement: '',
        vision_statement: ''
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAboutContent = async () => {
            try {
                const tenantSlug = getCurrentTenantSlug();
                const apiBaseUrl = getTenantApiUrl(tenantSlug);
                const url = `${apiBaseUrl}/tenant/about/`;
                
                const response = await axios.get(url);
                
                if (response.data && response.data.success && response.data.data) {
                    setAboutContent(response.data.data);
                }
            } catch (error) {
                console.error("Failed to fetch about content:", error);
                // Keep default content if API fails
            } finally {
                setLoading(false);
            }
        };

        fetchAboutContent();
    }, []);

    // Default content if API fails or while loading
    const defaultContent = {
        title: "About Us",
        description: "We want you to feel amazing about your oral wellness. Not just twice a year, but every time you take a bite, tell a joke, laugh, or share a kiss."
    };

    const content = loading ? defaultContent : {
        title: aboutContent.name || "About Us",
        description: aboutContent.about_description || aboutContent.tagline || defaultContent.description,
        tagline: aboutContent.tagline,
        owner: aboutContent.owner_name,
        location: [aboutContent.city, aboutContent.state, aboutContent.country].filter(Boolean).join(', '),
        phone: aboutContent.phone_number,
        website: aboutContent.website,
        logo: aboutContent.logo_url,
        primaryColor: aboutContent.primary_color,
        secondaryColor: aboutContent.secondary_color,
        yearsExperience: aboutContent.years_of_experience,
        specialties: aboutContent.specialties,
        certifications: aboutContent.certifications,
        mission: aboutContent.mission_statement,
        vision: aboutContent.vision_statement
    };

    return (
        <section className='about-section' data-aos="fade-up" data-aos-duration="2000">
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5">
                                <div className="about-banner-text">
                                    <h2>{content.title}</h2>
                                    {content.tagline && (
                                        <p className="tagline">{content.tagline}</p>
                                    )}
                                    <p>{content.description}</p>
                                    
                                    {content.owner && (
                                        <p className="owner-info">
                                            <strong>Lead Dentist:</strong> {content.owner}
                                            {content.yearsExperience && (
                                                <span className="experience"> • {content.yearsExperience} years of experience</span>
                                            )}
                                        </p>
                                    )}
                                    
                                    {content.specialties && (
                                        <p className="specialties-info">
                                            <strong>Specialties:</strong> {content.specialties}
                                        </p>
                                    )}
                                    
                                    {content.location && (
                                        <p className="location-info">
                                            <strong>Location:</strong> {content.location}
                                        </p>
                                    )}

                                    <div className="theme-btn">
                                        <Link 
                                            to='/contact'
                                            onClick={() => {
                                                trackContactUsClicked('About Page');
                                            }}
                                        >
                                            Contact Us
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="about-banner-img">
                                    <img src={bannerOne} alt="about banner"/>
                                    <img src={bannerTwo} alt="about banner two"/>
                                    <img className='pattern' src={pattern} alt="about banner two"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutBanner;